/* eslint-disable */
import createStore from "zustand";
import { configurePersist } from "zustand-persist";
import { UserDetailModel } from "./../types/UserDetailModel";

const { persist: _persist } = configurePersist({
  storage: localStorage,
  rootKey: "root",
});

const persist = _persist as any;

interface Auth {
  isAuthenticated?: boolean;
  isAuthenticating?: boolean;
  errorMessage?: string;
  accessToken?: string;
  user?: UserDetailModel;
}
interface AuthStore extends Auth {
  setAuth: (auth: Auth | ((auth: Auth) => Auth)) => void;
  clear: () => void;
}

const _useAuthStore11 = createStore<AuthStore>((set) => ({
  isAuthenticated: false,
  isAuthenticating: false,
  errorMessage: "error",
  accessToken: undefined,
  user: undefined,
  setAuth: (auth) => {
    if (typeof auth === "function") {
      set((_state) => auth(_state));
    } else {
      set((_state) => auth);
    }
  },
  clear: () => {
    set({});
  },
}));
export const useAuthStore = createStore<AuthStore>(
  persist(
    {
      key: "auth",
    },
    (set: any) => ({
      isAuthenticated: false,
      isAuthenticating: false,
      errorMessage: "error",
      accessToken: undefined,
      user: undefined,
      setAuth: (auth: Auth | ((auth: Auth) => Auth)) => {
        if (typeof auth === "function") {
          set((_state: Auth) => auth(_state));
        } else {
          set((_state: Auth) => auth);
        }
      },
      clear: () => {
        set((_state: any) => ({
          isAuthenticated: false,
          isAuthenticating: false,
          errorMessage: "error",
          accessToken: undefined,
          user: undefined,
        }));
      },
    })
  )
);
